listCacheSet